import type {EnvironmentProperty} from '@gongxigames/framework/slot/init';
import {CoreDI, Device, lazyInject} from '@gongxigames/framework/core';
import {ICheatPluginController} from '../../CheatModuleInterfaces';

type Info = Record<string, string>;

export class CheatInfoController implements ICheatPluginController {
    protected _info: Info = {};

    @lazyInject(CoreDI.Device)
    protected readonly device!: Device;

    @lazyInject(CoreDI.EnvironmentProperty)
    protected readonly environmentProperty!: EnvironmentProperty;

    public init(): void {
        const versions = this.environmentProperty.buildProperty.versions;
        const deviceInfo = this.device.info;

        // write versions from buildProperty
        Object.assign(this._info, versions);

        // write game keypadInfo
        Object.assign(this._info, deviceInfo);
    }

    public get information(): Info {
        return this._info;
    }
}
